import './YouTubeSection.css';
import underlineImg from '../assets/underline.png';
import { IconLightning } from './Icons';

const FEATURED_VIDEO_ID = 'YOUR_VIDEO_ID';

const STEPS = [
  {
    num: '01',
    title: 'Understand your brand',
    desc: 'We start by learning your product, audience, and goals — no generic playbooks.',
  },
  {
    num: '02',
    title: 'Build the right foundation',
    desc: 'From Shopify stores to Amazon listings, we set up infrastructure built to convert.',
  },
  {
    num: '03',
    title: 'Drive targeted traffic',
    desc: 'Performance marketing, SEO, and social commerce working together to bring buyers.',
  },
  {
    num: '04',
    title: 'Scale with data',
    desc: 'We track every metric that matters and double down on what actually grows revenue.',
  },
];

export default function YouTubeSection() {
  return (
    <section className="yt-section">
      <div className="yt-inner">

        {/* Left — video */}
        <div className="yt-left">
          <div className="yt-badge-wrap">
            <div className="badge">
              <span className="badge-icon"><IconLightning /></span>
              WATCH &amp; LEARN
            </div>
          </div>
          <div className="yt-video-wrap">
            <iframe
              className="yt-iframe"
              src={`https://www.youtube.com/embed/${FEATURED_VIDEO_ID}`}
              title="How we help you build e-commerce"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        {/* Right — content */}
        <div className="yt-right">
          <h2 className="yt-title">
            How we help you build
            <span className="yt-title-gradient"> <span style={{whiteSpace:'nowrap'}}>e-commerce</span></span>
          </h2>
          <img src={underlineImg} alt="" className="yt-underline" />
          <p className="yt-intro">
            We don't just run ads or build websites. We partner with you end-to-end —
            from strategy to execution — so your brand grows predictably and profitably.
          </p>

          <div className="yt-steps">
            {STEPS.map(s => (
              <div key={s.num} className="yt-step">
                <span className="yt-step-num">{s.num}</span>
                <div>
                  <p className="yt-step-title">{s.title}</p>
                  <p className="yt-step-desc">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
